import { FinancialStatementForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';

export const FINANCIAL_INVESTMENTS_TABLE_ARIA_LABEL = 'Фінансові інвестиції';
export const FINANCIAL_INVESTMENTS_SECTION_TITLES: Record<FinancialStatementForm, string> = {
  [FinancialStatementForm.Large]: '9. Розшифровка рядків Форми №1: фінансові інвестиції',
  [FinancialStatementForm.SmallOrSimplified]:
    '9. Розшифровка рядків Форми №1-м / Форми №1-мс: фінансові інвестиції',
};
export const FINANCIAL_INVESTMENTS_TABLE_MIN_WIDTH = 920;
export const FINANCIAL_INVESTMENTS_DATE_COLUMN_INDEXES = [4] as const;
export const FINANCIAL_INVESTMENTS_TABLE_HEADERS = [
  'Найменування підприємства / об’єкта інвестування',
  'ЄДРПОУ',
  'Питома вага, %',
  'Сума, тис. од.',
  'Дата початку інвестування',
] as const;
export const FINANCIAL_INVESTMENTS_TABLE_COLUMN_WIDTHS = [
  '42%',
  '14%',
  '14%',
  '15%',
  '15%',
] as const;
